"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = require("./enums");
//
//
//
//
//
var _default = exports.default = {
  name: "EasyTag",
  props: {
    colorType: {
      // success/info/warning/danger | colorTypeList
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    tagType: function tagType() {
      if (_enums.colorTypeList.includes(this.colorType)) {
        return '';
      }
      return this.colorType || this.$attrs.type || '';
    }
  }
};